import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';

@Component({
    selector: 'app-notification-bell',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './notification-bell.component.html',
    styleUrl: './notification-bell.component.scss'
})
export class NotificationBellComponent {
    private readonly alertsService = inject(AlertsService);
    private readonly router = inject(Router);

    // Get total count from service
    get totalCount(): number {
        return this.alertsService.totalAlertsCount;
    }

    // Individual counts for dropdown
    checkoutCount = this.alertsService.totalCheckoutCount;
    cleaningCount = this.alertsService.totalCleaningCount;
    lowStockCount = this.alertsService.totalLowStockCount;

    // Get recent alerts
    checkoutAlerts = this.alertsService.checkoutAlerts;
    cleaningAlerts = this.alertsService.cleaningAlerts;
    lowStockAlerts = this.alertsService.lowStockAlerts;

    // Dropdown state
    isDropdownOpen = false;

    /**
     * Toggle dropdown visibility
     */
    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    /**
     * Close dropdown
     */
    closeDropdown(): void {
        this.isDropdownOpen = false;
    }

    /**
     * Navigate to full alerts dashboard
     */
    viewAllAlerts(): void {
        this.router.navigate(['/admin/dashboard']);
        this.closeDropdown();
    }

    /**
     * Navigate to specific alert section
     */
    navigateTo(section: string): void {
        switch (section) {
            case 'checkout':
                this.router.navigate(['/admin/dashboard/reservacion'], {
                    queryParams: { filter: 'todas' }
                });
                break;
            case 'cleaning':
                this.router.navigate(['/admin/dashboard/limpieza']);
                break;
            case 'inventory':
                this.router.navigate(['/admin/dashboard/inventario'], {
                    queryParams: { stockBajo: 'true' }
                });
                break;
        }
        this.closeDropdown();
    }
}
